export const normalizedCompare = (a: string, b: string) => a.toLowerCase().trim() === b.toLowerCase().trim();

export const isEmailAddress = (str: string) =>
	/^[A-z0-9.! #$%&'*+/=? ^_`{|}~-]+@[A-z0-9-]+(?:\.[A-z0-9-]+)*$/.test(str);
